import { render } from "./LocalitaView.vue?vue&type=template&id=7678de52&scoped=true"
import script from "./LocalitaView.vue?vue&type=script&lang=js"
export * from "./LocalitaView.vue?vue&type=script&lang=js"

import "./LocalitaView.vue?vue&type=style&index=0&id=7678de52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7678de52"]])

export default __exports__